import { TBulkKeywords } from "@ts/common-types";

export function removeDuplicateObjects(objectArray: Array<TBulkKeywords>) {
    return Array.from(
        new Set(objectArray.map((data) => JSON.stringify(data)))
    ).map((objData) => JSON.parse(objData))
}

const uniqueSelectedKeywords = (bulkKeywordArray: Array<TBulkKeywords>) =>
    removeDuplicateObjects(bulkKeywordArray);

onmessage = (event) => postMessage(uniqueSelectedKeywords(event.data));